import { ArrowLeft, Home, SearchX, Sparkles } from 'lucide-react';
import { motion } from 'motion/react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { useRouter } from '@/hooks/use-router';

export function NotFoundPage() {
  const router = useRouter();

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-background px-6 py-10">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(59,130,246,0.12),transparent_30%),radial-gradient(circle_at_bottom_right,rgba(168,85,247,0.12),transparent_30%)]" />

      <motion.div
        initial={{ opacity: 0, scale: 0.96, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.35 }}
        className="relative w-full max-w-2xl"
      >
        <Card className="overflow-hidden border-border/50 bg-background/80 shadow-2xl backdrop-blur">
          <CardContent className="flex flex-col items-center px-8 py-16 text-center">
            <motion.div
              animate={{
                y: [0, -8, 0],
              }}
              transition={{
                duration: 3,
                repeat: Infinity,
                ease: 'easeInOut',
              }}
              className="relative mb-8"
            >
              <div className="absolute inset-0 rounded-full bg-blue-500/20 blur-3xl" />

              <div className="relative flex h-28 w-28 items-center justify-center rounded-full border border-blue-500/20 bg-blue-500/10">
                <SearchX className="h-14 w-14 text-blue-500" />
              </div>

              <motion.div
                animate={{
                  rotate: 360,
                }}
                transition={{
                  duration: 10,
                  repeat: Infinity,
                  ease: 'linear',
                }}
                className="absolute -right-2 -top-2"
              >
                <Sparkles className="h-6 w-6 text-violet-500" />
              </motion.div>
            </motion.div>

            <motion.h1
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
              className="mb-2 text-7xl font-black tracking-tight"
            >
              404
            </motion.h1>

            <motion.h2
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.15 }}
              className="mb-4 text-3xl font-bold tracking-tight"
            >
              Página não encontrada
            </motion.h2>

            <motion.p
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="mb-10 max-w-lg text-muted-foreground"
            >
              A página que você está tentando acessar não existe, foi removida ou o link
              está incorreto.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.25 }}
              className="flex flex-col gap-3 sm:flex-row"
            >
              <Button size="lg" onClick={() => router.push('/')} className="gap-2">
                <Home className="h-4 w-4" />
                Ir para o início
              </Button>

              <Button
                size="lg"
                variant="outline"
                onClick={() => window.history.back()}
                className="gap-2"
              >
                <ArrowLeft className="h-4 w-4" />
                Voltar
              </Button>
            </motion.div>
          </CardContent>
        </Card>
      </motion.div>
    </div>
  );
}
